<template>
  <li class="collection">
    <p
      class="title"
      @click="toggle"
    >
      <!-- 折叠图标 -->
      <span
        class="icon"
        :class="[open ? 'fold' : 'collapse']"
      />
      <span>我的收藏</span>
      <span class="start-num">
        {{ people }}人
      </span>
    </p>
    <ul
      v-show="open"
      class="starts"
    >
      <Member />
    </ul>
  </li>
</template>

<script>
import Member from './Member.vue';

export default {
  data() {
    return {
      open: false,
      people: 0,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  components: { Member },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
$line-height: 36px;

.collection {
  list-style: none;
  text-align: left;
  margin: 0 8px 0 8px;
  color: $blue;
  .title {
    padding-left: 14px;
    line-height: $line-height;
    height: $line-height;
    cursor: pointer;
    &:hover {
      background: $hover-color;
      border-radius: 1px;
    }
    .start-num{
      float: right;
      margin-right: 20px;
      color: $info;
    }
    .icon {
      margin-right: 3px;
      display: inline-block;
      background-size: 10px 10px;
      width: 10px;
      height: 10px;
    }
    .collapse {
      background-image: url("../../assets/home/address_book/arrow_collapse@2x.png");
    }
    .fold {
      background-image: url("../../assets/home/address_book/arrow_fold@2x.png");
    }
  }
  .starts {
    padding-left: 2em;
    list-style: none;
    .item {
      line-height: $line-height;
      height: $line-height;
    }
  }
}
</style>
